import { AxiosPromise } from 'axios';

import { hosts } from '@/app/config';
import { BaseClient } from '@/clients/BaseClient/BaseClient';
import { BestMatchesDto, ChatDto, CreateCampaignResponseDto, StartRJCommunicationPipelineDto } from '../model';

class RobinJrChatClient extends BaseClient {
  getCandidates(campaignId: number, offset: number = 0, limit: number = 5): AxiosPromise<BestMatchesDto> {
    return this.request({
      url: `${hosts.campaignsApi}/campaigns/${campaignId}/search_batch/`,
      method: 'POST',
      params: { limit, offset },
    });
  }

  getChat(chatId: number): AxiosPromise<ChatDto> {
    return this.request({
      url: `${hosts.chatApi}/chat/${chatId}/`,
      method: 'GET',
    });
  }

  hideCandidate(esPersonId: string, campaignId: number): AxiosPromise<void> {
    return this.request({
      url: `${hosts.campaignsApi}/campaigns/${campaignId}/candidates/`,
      method: 'POST',
      data: { es_person_id: esPersonId, status: 'HIDDEN' },
    });
  }

  getJobPreview(chatId: number, force: boolean = false): AxiosPromise<any> {
    return this.request({
      url: `${hosts.chatApi}/chat/${chatId}/job-preview/`,
      method: 'GET',
      params: { force },
    });
  }

  saveJobPreview(chatId: number, jobPreview: string): AxiosPromise<any> {
    return this.request({
      url: `${hosts.chatApi}/chat/${chatId}/job-preview/`,
      method: 'PUT',
      data: { edited_preview: jobPreview },
    });
  }

  createCampaign(chatId: number): AxiosPromise<CreateCampaignResponseDto> {
    return this.request({
      url: `${hosts.chatApi}/chat/${chatId}/campaign/`,
      method: 'POST',
    });
  }

  startRJCommunicationPipeline(params: StartRJCommunicationPipelineDto): AxiosPromise<void> {
    const { campaign_id, es_person_id, subject, message, improved_job_id, origin } = params;
    return this.request({
      url: `${hosts.campaignsApi}/campaigns/${campaign_id}/candidates/${es_person_id}/rj_communication_hub/start/`,
      method: 'POST',
      data: {
        subject,
        message,
        improved_job_id,
        ...(origin != null ? { origin } : {}),
      },
    });
  }

  getChatJobImproved(chatId: number) {
    return this.request({
      url: `${hosts.chatApi}/chat/${chatId}/job-improved/`,
      method: 'GET',
    });
  }
}

export const robinJrChatClient = new RobinJrChatClient();
